import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import { useFreeViewLimit } from './composables/use-free-view-limit';


export default /*#__PURE__*/_defineComponent({
  __name: 'PermissionTips',
  setup(__props) {

const windowHeight = ref(window.innerHeight);

const { overFreeViewLimitMessage } = useFreeViewLimit();

return { __sfc: true,windowHeight, overFreeViewLimitMessage }
}

})